import moment from 'moment';

export const formatDate = (date: any, time: boolean = false) => {
    if (!date) return 'Unknown';
    try {
        return moment(date).format(time ? 'M/DD/YYYY h:mm a' : 'l');
    } catch {
        return 'Invalid Date';
    }
};

export const formatCurrency = (amount: any) => {
    if (!amount || isNaN(amount)) return 'Unknown';
    try {
        return `${Math.floor(amount / 1000)}k`;
    } catch {
        return 'Invalid Amount';
    }
};

export const formatArray = (arr: any[]) => {
    if (!Array.isArray(arr)) return 'Unknown';
    return arr.join(', ') || 'None';
};
